import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import {styleForHeader} from '../../style.js';

export const GridColumns = [
    { field: 'id', hide: true},
    { field: 'name', width: 200, headerAlign:'center', text:'BİLDİRİM ADI',
        renderHeader: () => styleForHeader('BİLDİRİM ADI')
    },
    { field: 'smsOperator', width: 200, headerAlign:'center', text:'SMS OPERATÖRÜ',
        renderHeader: () => styleForHeader('SMS OPERATÖRÜ')
    },
    { field: 'isSendSms', width: 100, headerAlign:'center', align:'center', type: 'checkbox', text:'Sms',
        renderHeader: () => styleForHeader('SMS'),
        renderCell: (params) => styleForCheckbox(params.value)
    },
    { field: 'isOtpSms', width: 100, headerAlign:'center', align:'center', type: 'checkbox',  text:'Sms Otp',
        renderHeader: () => styleForHeader('SMS OTP'),
        renderCell: (params) => styleForCheckbox(params.value)
    },      
    { field: 'emailAddress', width: 200, headerAlign:'center', text:'E-POSTA ADRESİ', /* headerClassName: 'super-app-theme--header', */
        renderHeader: () => styleForHeader('E-POSTA ADRESİ')
    },    
    { field: 'isSendEmail', /* headerName:'EPOSTA', */ width: 100, headerAlign:'center', align:'center', type: 'checkbox',  text:'E-posta',
        renderHeader: () => styleForHeader('E-POSTA'),
        renderCell: (params) => styleForCheckbox(params.value)
    },    
    { field: 'isOtpEmail', width: 100, headerAlign:'center', align:'center', type: 'checkbox', text:'E-posta Otp',
        renderHeader: () => styleForHeader('E-POSTA OTP'),
        renderCell: (params) => styleForCheckbox(params.value)
    },            
    { field: 'recordStatus', hide: true}
];

export const styleForCheckbox = (value) => {
    return (
        <Checkbox checked={value} size="large" sx={{
            color: '#28a5ad',
            '&.Mui-checked': {
              color: '#28a5ad',
            }
          }} />
          /* color={params.value ? "success" : "default"} */
    )         
}